import React from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { ErrorService } from "../../services/errorService";
import { ErrorFallback } from "../errorFallbackView";

const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const onError = (exception: any) => {
    ErrorService.log(exception);
  };
  return (
    <ReactErrorBoundary FallbackComponent={ErrorFallback} onError={onError}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
